// extracted by mini-css-extract-plugin
export var actions = "_51-0";
export var actionsContainer = "_51-7";
export var border = "_51-1";
export var childFullHeight = "_51-f";
export var collapse = "_51-2";
export var content = "_51-a";
export var contentChild = "_51-e";
export var fullscreen = "_51-c";
export var hasLeftRadius = "_51-k";
export var headerContainer = "_51-3";
export var headerRow = "_51-5";
export var hidePadding = "_51-b";
export var navCollapsedGap = "_51-l";
export var noScrollX = "_51-m";
export var noScrollY = "_51-n";
export var noTopPadding = "_51-i";
export var optOutTopPadding = "_51-d";
export var pageMain = "_51-j";
export var pageOuter = "_51-g";
export var pagePadding = "_51-8";
export var pageScroll = "_51-9";
export var profile = "_51-o";
export var profileContainer = "_51-p";
export var profileImage = "_51-q";
export var profileMain = "_51-r";
export var profileSubtitle = "_51-t";
export var profileTitle = "_51-s";
export var showLeftPadding = "_51-h";
export var tabsPortalSlot = "_51-6";
export var tabsWrapper = "_51-4";
export var title = "_51-u";